import { apiPrefix } from 'src/settings';

export function getPamBaseUrl(): string {
    if (apiPrefix === 'dev.') {
        return 'https://dev.pam.cimpress.io';
    }
    return 'https://pam.cimpress.io';
}
